import { doctorAdapter } from './reducer'

export const { selectById: selectDoctorById } = doctorAdapter.getSelectors(
  state => state.doctors
)

export const { selectAll: selectRelatedFacilities } = doctorAdapter.getSelectors(
  state => state.doctors.related_facilities
)
